<template src="./fuel.html"></template>
<script>
import VueGallery from "vue-gallery";
import Multiselect from "vue-multiselect";
import Axios from "axios";
import $ from "jquery";
import { GChart } from "vue-google-charts";
import * as Chartist from "chartist";
var moment = require("moment");
let FuelByVehicle = "";
export default {
  components: {
    VueGallery,
    Multiselect,
    GChart,
  },
  filters: {
    date: function (data) {
      var sendDate = "N/A";
      if (data != "" && data != null) {
        sendDate = moment(data).format("DD-MM-YYYY");
      }
      return sendDate;
    },
  },
  data() {
    return {
      basic: {
        currentPage: 1,
        totalPages: 0,
      },
      VehicleImageEndpoint: Endpoints.Vehicle.Image + "/",
      ImageEndpoint: Endpoints.Helper.Image + "/",
      ShowLoader: false,
      showLocationDetails: false,
      ShowDashboardDetailPopup: false,
      TotalCost: 0,
      TotalMonthVolume: 0,
      TotalMonthCost: 0,
      TotalMonthAvgMpg: 0,
      TotalMonthAvgPerVehicleCost: 0,
      fromDate: "",
      toDate: "",
      DataLoader: true,
      infoOpened: false,
      locationPoints: "",
      SelectAllVehicle: false,
      VehicleRows: "",
      MileageUnit: "Miles",
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
        content: "",
      },
      Records: [],
      TableData: [],
      FuelDates: [],
      Vehicles: [],
      FuelDetails: [],
      FuelByMileage: [],
      FuelByCost: [],
      FuelByMultipleVehicle: [],
      FuelByVehicle: [],
      FuelRecords: {
        recordType: 1,
        vehicles: [],
      },
      filter: {
        currentPage: 1,
        totalPages: 0,
      },

      filters: {
        keywords: {
          value: "",
          keys: ["volume", "reg", "driver", "cost", "mileage", "time", "date"],
        },
      },
      center: {
        lat: 55.232753,
        lng: -3.944403,
      },
      FuelByVehicleSearch: {
        VehicleId: "0",
      },
      FuelListSearch: {
        VehicleId: "0",
      },

      areaspalinechart: {
        series: [
          /*{
              name: 'series1',
              data: [31, 40, 28, 51, 42, 109, 100],
            },
            {
              name: 'series2',
              data: [11, 32, 45, 32, 34, 52, 41],
            },*/
        ],
        chartOptions: {
          chart: {
            height: 350,
            type: "area",
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
            events: {
              click: function (event, chartContext, config) {
                FuelByVehicle = config.dataPointIndex;
              },
            },
          },
          markers: {
            size: [3, 4],
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
          },
          colors: ["#7366ff", "#f73164"],
          xaxis: {
            type: "text",
            categories: [],
          },
        },
      },
      fuelmultiplechart: {
        series: [
          /*{
              name: 'series1',
              data: [31, 40, 28, 51, 42, 109, 100],
            },
            {
              name: 'series2',
              data: [11, 32, 45, 32, 34, 52, 41],
            },*/
        ],
        chartOptions: {
          chart: {
            height: 350,
            type: "area",
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
            events: {
              click: function (event, chartContext, config) {
                FuelByVehicle = config.dataPointIndex;
              },
            },
          },
          markers: {
            size: [3, 4],
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
          },
          colors: [
            "#7366ff",
            "#f73164",
            "#058FE9",
            "#EC110C",
            "#EC950C",
            "#2CEC0C",
          ],
          xaxis: {
            type: "text",
            categories: [],
          },
        },
      },
    };
  },
  mounted() {
    var AccountPermissions = JSON.parse(
      localStorage.getItem("AccountPermissions")
    );
    var FleetSubscription = JSON.parse(
      localStorage.getItem("FleetSubscription")
    );
    var FleetSubscriptionModules = JSON.parse(FleetSubscription.fleet_modules);
    if (
      FleetSubscriptionModules["Hierarchy System"] &&
      (!AccountPermissions["Fuel Tracking"] ||
        !AccountPermissions["Fuel Tracking"]["enable"])
    ) {
      this.$router.push("/");
    }
    document.title = pbx_SiteTitle + " - Reports";
    this.GetVehiclesListForAssign();
    //this.GetFuelDocuments();
    this.GetFuelReport();
    this.GetFuelByVehicle();
    this.GetFuelList();
    var CompanyData = JSON.parse(localStorage.getItem("Company"));
    if (CompanyData.mileage_unit == 2) {
      this.MileageUnit = "KM";
    }
  },

  methods: {
    GetVehiclesListForAssign() {
      var obj = { token: localStorage.getItem("token") };
      Axios.post(Endpoints.Vehicle.List, obj).then((Response) => {
        if (Response.data.success) {
          this.Vehicles = Response.data.vehicles;
        }
      });
    },
    selectFuelByVehicle() {
      if (FuelByVehicle >= 0) {
        this.FuelDetails = [];
        this.ShowDashboardDetailPopup = true;
        var obj = {
          token: localStorage.getItem("token"),
          category: "fuel",
          sub_category: "fuel",
          VehicleId: this.FuelByVehicleSearch.VehicleId,
          from_date: "",
          to_date: "",
          date_month: this.Records[FuelByVehicle].date3,
        };
        Axios.post(Endpoints.Report.FuelList, obj).then((Response) => {
          if (Response.data.success) {
            this.FuelDetails = Response.data.recordsList;
          }
        });
      }
    },
    SearchByMultipleVehicle() {
      var obj = {
        token: localStorage.getItem("token"),
        search_type: this.FuelRecords.recordType,
        vehicle_ids: this.FuelRecords.vehicles,
      };
      Axios.post(Endpoints.Report.FuelByMultipleVehicle, obj).then(
        (Response) => {
          if (Response.data.success) {
            this.FuelByMultipleVehicle = {};
            var data = Response.data.services;
            if (data.length > 0) {
              var vehicleIds = Response.data.vehicleIds;
              this.FuelByMultipleVehicle = {};
              this.FuelByMultipleVehicle.series = [];
              vehicleIds.forEach((element, index) => {
                this.VehicleRows = {
                  name: element["vrm"],
                  data: [],
                };
                this.FuelByMultipleVehicle.series.push(this.VehicleRows);
              });
              data.forEach((element, index) => {
                element["vehicles"].forEach((element2, index2) => {
                  if (this.FuelRecords.recordType == 1) {
                    this.FuelByMultipleVehicle.series[index2]["data"].push(
                      +element2["volume"]
                    );
                  }
                  if (this.FuelRecords.recordType == 2) {
                    this.FuelByMultipleVehicle.series[index2]["data"].push(
                      +element2["mpg"]
                    );
                  }
                  if (this.FuelRecords.recordType == 3) {
                    this.FuelByMultipleVehicle.series[index2]["data"].push(
                      +element2["cost"]
                    );
                  }
                });
                this.fuelmultiplechart.chartOptions.xaxis.categories.push(
                  element["date3"]
                );
              });
              this.ShowMultipleVehiclePopup = false;
              //this.ResetVehicleArray();
            } else {
              this.$swal
                .fire("Error: No Record Found", "", "error")
                .then(() => {});
            }
          }
        }
      );
    },
    ShowLocationMap(fuelDetails) {
      this.showLocationDetails = true;
      const marker = {
        lat: parseFloat(fuelDetails.latitude),
        lng: parseFloat(fuelDetails.longitude),
      };
      //this.center = marker;
      this.locationPoints = marker;
      this.infoOpened = true;
      this.infoOptions.content =
        '<div id="mapcontent"><h1 id="firstHeading" class="firstHeading" style="margin: 0px;">' +
        fuelDetails.reg +
        "</h1></div>";
    },
    DownloadDocument(file) {
      window.open(this.ImageEndpoint + file, "_blank");
    },
    GetFuelDocuments() {
      var obj = {
        token: localStorage.getItem("token"),
        category: "fuel",
        sub_category: "fuel",
      };
      Axios.post(Endpoints.Report.FuelByVehicle, obj).then((Response) => {
        if (Response.data.success) {
          this.TableData = Response.data.recordsList;
          this.TotalCost = Response.data.totalCost;
          this.DataLoader = false;
        }
      });
    },
    GetFuelReport() {
      var obj = {
        token: localStorage.getItem("token"),
        VehicleId: 0,
        from_date: "",
        to_date: "",
      };
      Axios.post(Endpoints.Report.FuelReportGet, obj).then((Response) => {
        if (Response.data.success) {
          this.TotalMonthVolume = Response.data.totalMonthlyVolume;
          this.TotalMonthCost = Response.data.totalMonthlyCost;
          this.TotalMonthAvgMpg = Response.data.totalMonthlyAvgMpg;
          this.TotalMonthAvgPerVehicleCost = Response.data.avgPerVehicleCost;
        }
      });
    },
    GetFuelList() {
      var obj = {
        token: localStorage.getItem("token"),
        category: "fuel",
        sub_category: "fuel",
        VehicleId: this.FuelListSearch.VehicleId,
        from_date: this.fromDate,
        to_date: this.toDate,
        date_month: "",
      };
      Axios.post(Endpoints.Report.FuelList, obj).then((Response) => {
        if (Response.data.success) {
          this.TableData = Response.data.recordsList;
          this.TotalCost = Response.data.totalCost;
          this.fromDate = Response.data.start_date;
          this.toDate = Response.data.end_date;
        }
      });
    },
    GetFuelByVehicle(type = "") {
      var obj = {
        token: localStorage.getItem("token"),
        category: "fuel",
        sub_category: "fuel",
      };
      if (type == "search") {
        obj.VehicleId = this.FuelByVehicleSearch.VehicleId;
      }
      Axios.post(Endpoints.Report.FuelByVehicle, obj).then((Response) => {
        this.DataLoader = false;
        if (Response.data.success) {
          this.Records = Response.data.services;

          this.FuelByVehicle = {};
          this.FuelByMileage = {};
          this.FuelByCost = {};
          var data = Response.data.services;

          //if (data.length > 1) {
          this.FuelByVehicle = {};
          this.FuelByVehicle.series = [
            { name: "Useage By Month", data: [] },
            { name: "Total Overall Useage", data: [] },
          ];
          this.FuelByMileage = {};
          this.FuelByMileage.series = [
            { name: "MPG By Month", data: [] },
            { name: "Average MPG", data: [] },
          ];
          this.FuelByCost = {};
          this.FuelByCost.series = [
            { name: "Spend By Month (£)", data: [] },
            { name: "Total Overall Spend (£)", data: [] },
          ];

          this.FuelDates = [];

          data.forEach((element, index) => {
            this.FuelByVehicle.series[0]["data"].push(+element["volume"]);
            this.FuelByVehicle.series[1]["data"].push(+element["total_volume"]);

            this.FuelByMileage.series[0]["data"].push(+element["mgp"]);
            this.FuelByMileage.series[1]["data"].push(+element["avg_mgp"]);

            this.FuelByCost.series[0]["data"].push(+element["cost"]);
            this.FuelByCost.series[1]["data"].push(+element["total_cost"]);

            this.areaspalinechart.chartOptions.xaxis.categories.push(
              element["date3"]
            );

            this.FuelDates.push(element["date3"]);
          });

          //Update xaxis data
          this.areaspalinechart.chartOptions = {
            chart: {
              height: 350,
              type: "area",
              zoom: {
                enabled: false,
              },
              toolbar: {
                show: false,
              },
              events: {
                click: function (event, chartContext, config) {
                  FuelByVehicle = config.dataPointIndex;
                },
              },
            },
            markers: {
              size: [3, 4],
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: "smooth",
            },
            colors: ["#7366ff", "#f73164"],
            xaxis: {
              categories: this.FuelDates,
            },
          };

          //}
        }
      });
    },
  },
};
</script>

<style type="text/css">
.custom-scrollbar thead th.heading-padding-left {
  padding-left: 0.75rem !important;
}
g {
  cursor: pointer;
}
.margin-auto {
  margin: 0 auto;
}
.vehicle-details-modal {
  width: 100%;
}
.margin-right-auto {
  margin-right: auto !important;
}
.detail-link {
  color: #000;
}
.detail-link:hover {
  color: #000;
}
.filter-input-width {
  width: 20% !important;
}
#showOwnerDetails .modal-header {
  border-bottom: 0px !important;
}
#showOwnerDetails .modal-title {
  font-size: 14px !important;
}
.modal-table .table th,
.table td {
  padding: 0.75rem !important;
}
.vehicle-info-modal,
.owner-info-modal {
  padding-top: 0px !important;
}
#showVehicleDetails .modal-header {
  border-bottom: 0px !important;
}
#showVehicleDetails .modal-title {
  font-size: 14px !important;
}
.cursor-pointer {
  cursor: pointer;
}
.map-modal-body {
  max-width: 1200px !important;
}
.page-link {
  line-height: 1.5 !important;
  height: 36px !important;
}
.card .report-icon {
  width: 83px;
}
.card .report-icon .report-icon-inner {
  border: 2px solid #8f4f88;
  height: 100%;
  width: 52px;
  text-align: center;
  margin-left: 6px;
  border-radius: 29px;
  padding: 11px;
  font-size: 17px;
  color: #8f4f88;
}
.card .report-number {
  width: 70%;
}
.card .report-average {
  margin-top: 25px;
}
.card .report-average span {
  color: rgb(143, 79, 136);
  font-size: 16px;
  font-weight: 400;
}
.report-box {
  background-image: url("../../assets/images/widget-bg.1e03d67b.png");
  background-position: right;
  overflow: hidden;
  background-repeat: no-repeat;
  border-radius: 10px;
}
.multiselect__tag {
  color: #fff !important;
  display: inline-block !important;
}
.multiselect__tag span {
  color: #fff !important;
}
.multiple-report {
  min-height: 529px;
}
</style>
